import React from 'react'

export default function Search(props){
    return(
        <div className="search-component">
            <div className="search">
                <h3 className="text-light">Address Search</h3>
                <div id="geo-container" className="geocoder"></div>
            </div>
            <div className="map-annotation">
                <div className='address'>
                    <h3 className="text-light">Site Address</h3>
                    <h2 className="text-bold">{props.address}</h2>
                </div>
                <div className='coordinates'>
                    <h3 className="text-light">Geocoordinates (Lat, Lon)</h3>
                    <h2 className="text-bold">{props.lat}, {props.lon}</h2>
                </div>
            </div>
        </div>
    )
}